var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgHome5L({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 505,
    height: 512,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      fill: "#77c69b",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ADF084",
    d: "M275.184 330.969c26.303-64.786 101.965-95.313 168.996-68.183 65.753 26.612 87.85 88.195 17.121 140.738-2.264 1.682-2.695 5.033-1.006 7.304 82.509 110.945-45.169 113.361-111.365 86.57-67.031-27.13-100.048-101.643-73.746-166.429Z",
    style: {
      fill: "#77c69b",
      fillOpacity: 1
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0E0E2C",
    strokeLinecap: "square",
    strokeWidth: 5,
    d: "M-57.802 345.588c19.945-19.57 24.517-50.071 21.497-77.837-3.02-27.767-12.763-54.293-17.135-81.701-8.144-48.466.039-99.451 23.036-142.972 7.057-13.623 16.196-26.893 29.402-34.37 13.205-7.478 31.814-7.529 42.526 3.554 11.015 11.544 9.873 29.746 5.808 45.107-3.747 13.83-9.868 33.713-5.714 48.703 4.691 17.018 21.346 28.695 37.228 15.626 22.172-17.99 36.23-46.124 52.715-70.562 7.932-11.685 24.693-40.536 39.793-42.91 35.02-5.666 3.97 62.047.498 80.324-1.498 7.991-2.604 16.782 1.145 24.105 21.847 40.133 113.845-100.506 145.08-22.904 6.987 17.494-3.795 37.528-18.683 48.887-26.385 19.83-61.385 26.937-85.736 49.663-18.951 17.86-31.156 48.215-20.668 73.459 14.829 35.484 57.935 35.088 89.416 39.943 41.34 6.581 82.877 24.138 118.78 44.997"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgHome5L);
export default __webpack_public_path__ + "static/media/bg_home5_l.84e239a7a1ad0470b551d40f41501f0f.svg";
export { ForwardRef as ReactComponent };